import { render, staticRenderFns } from "./RoleStaff.vue?vue&type=template&id=eb296ed6&scoped=true"
import script from "./RoleStaff.vue?vue&type=script&lang=js"
export * from "./RoleStaff.vue?vue&type=script&lang=js"
import style0 from "./RoleStaff.vue?vue&type=style&index=0&id=eb296ed6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb296ed6",
  null
  
)

export default component.exports